// extracted by mini-css-extract-plugin
module.exports = {"likesCount":"styles-module__likesCount___2amDf","likeIcon":"styles-module__likeIcon___1U8aT"};